import { render, staticRenderFns } from "./AllCompetencesTab.vue?vue&type=template&id=6502e438&scoped=true&"
import script from "./AllCompetencesTab.vue?vue&type=script&lang=js&"
export * from "./AllCompetencesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6502e438",
  null
  
)

export default component.exports